import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSidebarRightHide32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconSidebarRightHide32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7 8h12v16H7a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2m18 0h-4v16h4a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2m0 18H7a4 4 0 0 1-4-4V10a4 4 0 0 1 4-4h18a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4M10.485 13.172a1 1 0 0 1 1.415-1.415l3.535 3.536.707.707-.707.707-3.536 3.536a1 1 0 0 1-1.414-1.415L13.314 16z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSidebarRightHide32);
